import {
  PLAN_OS_ERROR,
  PLAN_OS_SUCCESS,
  PLAN_OS_LOADING,
  PLAN_OS_RESET,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";
import planObraSocialInitialState from "../initialStates/planObraSocialInitialState";

const planObraSocial = (state, { payload, type }) => {
  switch (type) {
    case PLAN_OS_LOADING:
      return {
        ...state,
        planObraSocial: {
          ...state.planObraSocial,
          error: false,
          loading: true,
        },
      };
    case PLAN_OS_SUCCESS:
      return {
        ...state,
        planObraSocial: {
          ...state.planObraSocial,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case PLAN_OS_ERROR:
      return {
        ...state,
        planObraSocial: {
          ...state.planObraSocial,
          error: payload,
          loading: false,
        },
      };

    case PLAN_OS_RESET:
      return planObraSocialInitialState;
    case RESET_PORTAL_CONTEXT:
      return planObraSocialInitialState;

    default:
      return state;
  }
};

export default planObraSocial;
